import React from 'react';

function Copy(props) {
    const className = props.className;
    const fill = props.fill;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="16" 
            viewBox="0 0 18 16" 
            fill="none"
            className={className}
        >
            <path 
                d="M14.7843 1.40091C16.6522 3.26879 16.6522 6.29722 14.7843 8.1651L13.2342 9.71523C12.8451 10.1044 12.2142 10.1044 11.825 9.71523C11.4359 9.32608 11.4359 8.69516 11.825 8.30602L13.1958 6.93525C14.3844 5.7466 14.4647 3.89971 13.3751 2.81012C12.2855 1.72052 10.4387 1.80082 9.25001 2.98947L7.87923 4.36024C7.49009 4.74938 6.85917 4.74938 6.47003 4.36024C6.08089 3.9711 6.08089 3.34018 6.47003 2.95104L8.02016 1.40091C9.88803 -0.46697 12.9165 -0.46697 14.7843 1.40091Z" 
                fill={fill}
            />
            <path 
                d="M11.4022 4.783C10.9353 4.31603 10.1782 4.31603 9.7112 4.783L5.76543 8.72878C5.29846 9.19575 5.29846 9.95286 5.76543 10.4198C6.2324 10.8868 6.9895 10.8868 7.45647 10.4198L11.4022 6.47405C11.8692 6.00708 11.8692 5.24997 11.4022 4.783Z" 
                fill={fill}
            />
            <path 
                d="M2.38333 13.8019C4.25121 15.6698 7.27964 15.6698 9.14752 13.8019L10.6976 12.2518C11.0868 11.8627 11.0868 11.2317 10.6976 10.8426C10.3085 10.4534 9.67758 10.4534 9.28844 10.8426L7.91767 12.2134C6.72902 13.402 4.88213 13.4823 3.79254 12.3927C2.70294 11.3031 2.78324 9.45624 3.97189 8.26759L5.34266 6.89681C5.73181 6.50767 5.73181 5.87675 5.34266 5.48761C4.95352 5.09847 4.3226 5.09846 3.93346 5.48761L2.38333 7.03773C0.515452 8.90561 0.515452 11.934 2.38333 13.8019Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Copy;